<div *ngIf="pathTest; else noPathTest" class="container-fluid p-2" style="min-height: 770px;">
  <div class="pb-0 d-flex flex-wrap">
    <div class="py-2 d-flex flex-row">
      <app-path-test-header [pathTestDoc]="pathTest"></app-path-test-header>
      <div class="btn-group px-1 pb-sm-3 my-auto text-nowrap" *ngIf="roleMgr.canEditTasks" dropdown>
        <a id="edit-options-btn" href="javascript:false;" behavior="button" dropdownToggle class="dropdown-toggle" aria-controls="dropdown-edit-options">
            <span class="caret"></span>
        </a>
        <ul style="z-index:9999;min-width:3rem;" id="dropdown-edit-options" *dropdownMenu class="p-1 dropdown-menu"
            role="menu" aria-labelledby="edit-options-btn">
            <li role="menuitem" style="margin-bottom:2px;margin-top:2px;">
              <button class="btn btn-secondary w-100 text-left" style="border-radius:0;"
                [disabled]="!roleMgr.canEditPointTests" (click)="onOpenPathEditDlg()">
                  <i class="fa fa-edit mr-1"></i>
                  Edit
              </button>
            </li>
            <li role="menuitem" style="margin-bottom:2px;">
              <button class="btn btn-secondary w-100 text-left" style="border-radius:0;"
                  (click)="onExportPath()">
                  <i class="fa fa-download mr-1"></i>
                Export
              </button>
            </li>
            <li role="menuitem">
              <button class="btn btn-danger w-100 text-left" style="border-radius:0;"
                  [disabled]="!roleMgr.canEditPointTests" (click)="onDeletePathTest()">
                  <i class="fa fa-trash mr-1"></i>
                Delete
              </button>
            </li>
            <li class="divider dropdown-divider"></li>
            <li role="menuitem" style="margin-bottom:2px;">
              <button class="btn btn-secondary w-100 text-left" style="border-radius:0;"
                (click)="onShowTestingSummary()">
                  <i class="fa fa-th-list mr-1"></i>
                  Testing Summary
              </button>
            </li>
            <li role="menuitem" style="margin-bottom:2px;">
              <button class="btn btn-secondary w-100 text-left" style="border-radius:0;"
                (click)="onShowDialerCallLogs()">
                  <i class="fa fa-database mr-1"></i>
                  Dialer Call Logs
              </button>
            </li>
        </ul>
      </div>
    </div>
    <div class="ml-auto">
    <div [ngClass]="!showingPointComponent?'d-none':'d-flex flex-row'" class="selected-tab justify-content-between pt-1">
      <app-path-test-point-paginator
      [pathTest]="pathTest"
        [changeGuard]="changeSelectedPointTestGuard">
      </app-path-test-point-paginator>
      <div class="editor-close">
        <i class="fa fa-window-close text-secondary"  role="button" (click)="onCloseEditor()"></i>
      </div>
    </div>
    </div>
  </div>
  <div *ngIf="!showingPointComponent">
    <div *ngIf="!appState.isReady||bInitializing" class="font-weight-bold {{bInitializing?'disabled-overlay':'busy-overlay'}}">
      <span class="badge badge-pill bg-white"><i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...</span>
    </div>
    <div class="d-flex flex-wrap p-2" *ngrxLet="store.testPoints$ as testPoints">
      <div class="pr-lg-3" [ngClass]="{'d-none':hideTestPointsTable}" #leftDiv >
        <ng-container *ngrxLet="store.mapData$ as mapData">
        <ng-container *ngrxLet="store.testPoint$ as selectedTestPoint">
        <ng-container *ngrxLet="store.testPoint$ as selectedTestPoint">
          <app-path-test-point-list
            [pathTest]="pathTest"
            [testPoints]="testPoints || []"
            [scoutPointInfoByPtId]="scoutPointInfoByPtId"
            [initializingScoutInfoByPtId]="initializingScoutInfoByPtId"
            [mapData]="mapData"
            [selectedTestPoint]="selectedTestPoint"
            (selectedTestPointChange)="onChangeSelectedTestPoint($event)"
            [editFn]="onEditPointTest"
            [editFnDrive]="onEditPointTestDrive"
            [visibleColumns]="visibleColumns">
          </app-path-test-point-list>
        </ng-container>
        </ng-container>
        </ng-container>
        <div class="d-flex flex-row justify-content-between">
          <div>
            <div *ngIf="lastChange" class="pl-1 font-italic text-secondary small">
              {{lastChange.seq?.startTime|date:'yyyy-MM-dd HH:mm:ss'}} (Local) {{lastChange.userName$ | async}} on
              <a href="javascript:false;" (click)="onEditPointTest(lastChange.testPoint)">
                {{lastChange.testPoint?.pointId}}
              </a>
            </div>
          </div>
          <div class="small btn-group px-1 text-nowrap" dropdown [align]="'right'" *ngIf="pathTest?.type!='drive test'">
            <a id="table-detail-btn" href="javascript:false;" behavior="button" (click)="showTaskCalls()" >
              Calls
            </a>
            <span class="text-secondary mx-2">|</span>
            <a id="table-detail-btn" href="javascript:false;" behavior="button" dropdownToggle
                class="dropdown-toggle" aria-controls="dropdown-edit-options">
              Show/Hide <span class="caret"></span>
            </a>
            <ul style="z-index:9999;min-width:3rem;"
                id="dropdown-table-detail-options" *dropdownMenu class="dropdown-menu"
                role="menu" aria-labelledby="table-detail-btn">
                <li role="button" class="px-2"
                    (click)="visibleColumns.scoutPtInfo=!visibleColumns.scoutPtInfo">
                  <i class="far" [ngClass]="visibleColumns.scoutPtInfo?'fa-check-square':'fa-square'"></i> Scout Info
                </li>
                <li role="button" class="px-2"
                    (click)="visibleColumns.environment=!visibleColumns.environment">
                  <i class="far" [ngClass]="visibleColumns.environment?'fa-check-square':'fa-square'"></i> Environment
                </li>
                <li role="button" class="px-2"
                    (click)="visibleColumns.callCounts=!visibleColumns.callCounts">
                  <i class="far" [ngClass]="visibleColumns.callCounts?'fa-check-square':'fa-square'"></i> Call Counts
                </li>
                <li role="button" class="px-2"
                    (click)="visibleColumns.time=!visibleColumns.time">
                  <i class="far" [ngClass]="visibleColumns.time?'fa-check-square':'fa-square'"></i> Time
                </li>
                <li role="button" class="px-2"
                    (click)="visibleColumns.comments=!visibleColumns.comments">
                  <i class="far" [ngClass]="visibleColumns.comments?'fa-check-square':'fa-square'"></i> Comments
                </li>
                <li role="button" class="px-2"
                    (click)="visibleColumns.seqStatus=!visibleColumns.seqStatus">
                  <i class="far" [ngClass]="visibleColumns.seqStatus?'fa-check-square':'fa-square'"></i> Sequence Status
                </li>
            </ul>
          </div>
        </div>
        <div class="row p-3">
          <span class="gray font-italic pl-2">Access Procedures/Notes</span>
            <textarea (dblclick)="editNotes()" [readonly]="notesFieldDisabled" [(ngModel)]="notes" (ngModelChange)="notesChangeFn($event)"  rows="4" class="form-control" style="resize: none"></textarea>
        </div>

        <div class="d-flex flex-row justify-content-end" *ngIf="isNotesSaveButtonShown">
          <button class="btn btn-secondary btn-sm small" [disabled]="!notesFieldDirty" (click)="onSaveNotes()">Save</button>
          &nbsp;
          <button class="btn btn-secondary btn-sm small" type="button" (click)="onCancel()">Cancel</button>
        </div>

        <div class="row px-3">
          <app-path-test-log #pathTestLog [pathTest]="pathTest" class="w-100"></app-path-test-log>
        </div>
      </div>
      <div class="d-flex flex-column flex-grow-1 busy-overlay-parent" *ngIf="mapHeight">
        <div *ngIf="bLoadingWaypoints||bLoadingPoints" class="font-weight-bold disabled-overlay">
          <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
        </div>
        <ng-container *ngrxLet="store.mapData$ as mapData">
        <ng-container *ngrxLet="store.mapPoint$ as selectedMapPoint">
          <div style="min-width: 400px;" [ngStyle]="{'min-height': mapHeight}" class="flex-grow-1">
            <app-path-test-plotter #pathTestPlotter *ngIf="bTabActive"
            [pathTest]="pathTest"
            [mapPoints]="mapData?.mapPoints || []"
            [selectedMapPoint]="selectedMapPoint"
            [scoutPtInfoByPtId]="scoutPointInfoByPtId"
            [overlay]="pathTestOverlay||(fallbackToScoutOverlay&&scoutPath?.overlay)"
            (pointSelected)="onPlotterPointSelected($event)"
            [showRefDataFn]=""
            [deletePointFn]=""
            [locked]="false"
            [gpx]="pathTestGpx"
            (overlayIntializing)="overlayLoading=$event"
            class="px-0"
            [miscLeafNodeEventFn]="onMiscLeafNodeEvent"
            [bInfoMarkersVisible]="!correlationVisible"
            >
            </app-path-test-plotter>
          </div>
          <app-map-point-summary [mapPoint]="selectedMapPoint">
          </app-map-point-summary>
        </ng-container>
        </ng-container>
        <div class="d-flex">
          <i *ngIf="overlayLoading" class="fa fa-spin fa-spinner text-muted"
            style="position:absolute;bottom:15px;right:10px;z-index:10;"></i>
          <div class="flex-grow-1" [ngClass]="uiLocked?'disabled':''">
          <app-path-test-overlay [pathTestDoc]="pathTest" [overlay]="pathTestOverlay" [readonly]="uiLocked"
              [fallbackOverlay]="scoutPath?.overlay" [fallbackOverlayCopyTitle]="'Copy Scout Overlay'"
              (overlayEdited)="onOverlayEdited($event)" (gpxEdited)="onGpxEdited($event)" >
          </app-path-test-overlay>
          </div>
          <div *ngIf="!pathTestOverlay && scoutPath?.overlay" class="'disabled'">
            <app-scout-path-overlay [scoutTaskDoc]="scoutTask" [scoutPath]="scoutPath" [overlay]="scoutPath?.overlay"
            [readonly]='true' [headerTitle]="'Scout Overlay'"> 
              <input type="checkbox" [(ngModel)]="fallbackToScoutOverlay"/>                           
            </app-scout-path-overlay>
          </div>
        </div>
      </div>
    </div>


    <div class="px-2">
      <div class="mb-2">
      <table class="table table-sm my-0 w-100">
        <tr>
          <th role="button" (click)="toggleCorrelationVisible()" style="width: 10em;" class="text-nowrap">
            Correlation
            <i class="ml-1 fa {{correlationVisible?'fa-chevron-down':'fa-chevron-right'}}"></i>            
          </th>
          <td class="text-right pt-0 w-100">
            <span class="text-muted small" *ngIf="correlationTable">
              <input type="checkbox" class="ml-1" [(ngModel)]="correlationTable.bShowDataRows"/>
              Correlation Table
            </span>
            <span class="text-muted ml-3 small">
              <input type="checkbox" class="ml-1" [(ngModel)]="hideTestPointsTable"/>
              Hide Path Info
            </span>
            <span class="text-muted mx-3" title="Sets minimum height of map">
            Map <select class="form-select" [(ngModel)]="mapHeight" (change)="onMapHeightChange($event)">
              <option value="">Hide</option>
              <option value="300px">Small</option>
              <option value="550px">Medium</option>
              <option value="800px">Large</option>
              <option value="1200px">Extra Large</option>  
            </select>
            </span>
            <span class="text-muted ml-1">
              <button class="btn btn-outline-secondary btn-sm small px-1 py-0" (click)="showKmlViewer();">
              <i class="fa fa-globe mr-1"></i>KML
            </button>
            </span> 
        </td>
        </tr>
      </table>
      </div>
      <ng-container *ngIf="!bLoadingWaypoints&&!bLoadingPoints&&correlationVisible">
        <ng-template #correlationCellRendererTmpl
            let-record="record" let-column="column" let-tableComponent="tableComponent" let-showRequestFn="showRequestFn"
        >
          <td fes-correlation-table-cell-renderer [record]="record" [column]="column" [tableComponent]="tableComponent" (showRequest)="showRequestFn($event)">
          </td>
        </ng-template>
        <app-correlation-table #correlationTable class="mt-1"
        [alternateViewsEnabled]="false"
        [statGroups]="correlationStatGroups"
        [pageSize]="1000"
        (recordsLoaded)="onCorrelationRecordsLoaded($event)"
        [loadOnInit]="true"
        [contextJson]="correlationContext"
        (contextJsonChange)="correlationContext=$event"
        [cellRendererTmplRef]="correlationCellRendererTmpl"
        (rowMouseOverEmitter)="correlationRowHover($event,true)"
        (rowMouseOutEmitter)="correlationRowHover($event,false)">
        </app-correlation-table>
      </ng-container>
    </div>



    <app-path-scout-source class="mx-2"
    *ngIf="pathTest.type === 'path test'"
      [bTabSelected]="bTabActive"
      [pathId]="pathTest.pathId"
      [stage]="pathTest.stage"
      [selectedPointId]="(store.mapPoint$|async)?.pointData?.pointId"
      [buildingId]="pathTest.buildingId"
      (resolvedScoutPath)="onResolvedScoutPath($event)"
      >
    </app-path-scout-source>
  </div>
  <div *ngIf="showingPointComponent" class="editor-parent d-flex flex-row w-100 p-3">
    <app-path-test-point #pathTestPointComponent
        [pathTestOverlay]="pathTestOverlay"
        [routeGPX]="pathTestGpx"
        [changeSelectedMapPointTestGuard]="changeSelectedMapPointTestGuard"
        [bTabActive]="bTabActive"
        class="w-100">
    </app-path-test-point>
  </div>
</div>

<ng-template #noPathTest>
  <div class="d-flex h-100 justify-content-center align-items-center text-nowrap" style="min-height: 300px;">
    <i *ngIf="bInitializing" class="fa fa-spinner fa-spin"></i>&nbsp;{{bInitializing?'Loading...':'No Path Test'}}
  </div>
</ng-template>